<div id="main" class="app-admin-wrap h-100">
  <header class="header" [class.over]="showInfoContent">
    <mat-toolbar class="top-toolbar" [class.mat-elevation-z7]="settings.fixedHeader">
      <div class="layout-toolbar-flex">
        <div class="layout-toolbar-section layout-toolbar-center">
          <a routerLink="/" class="logo" ngClass.xs="mobile" (click)="closeSubMenus()">
            <img [src]="appLogo()" alt="logo" />
            <span class="mx-2">{{ appName() }}</span>
          </a>
        </div>
        <div class="layout-toolbar-section layout-toolbar-left w-100">
          @if (isMobile) {
            <button mat-icon-button (click)="sidenav()?.toggle()">
              <mat-icon>menu</mat-icon>
            </button>
          }
        </div>
        <div class="layout-toolbar-section layout-toolbar-right">
          <app-user-menu></app-user-menu>
        </div>
      </div>
    </mat-toolbar>
  </header>

  <mat-drawer-container class="page-wrapper app-admin-container app-side-nav-container mat-drawer-transition">
    @if (settings.menu == 'vertical') {
      <mat-drawer
        #sidenav
        [opened]="settings.sidenavIsOpened"
        [mode]="settings.sidenavIsPinned ? 'side' : 'over'"
        (openedStart)="showSidenav = !showSidenav"
        (closedStart)="showSidenav = !showSidenav"
        class="sidenav mat-elevation-z6"
        [class.collapsed]="sidenavCollapsed"
        autoFocus="false"
      >
        @if (settings.fixedSidenav) {
          <mat-toolbar class="top-toolbar">
            <a routerLink="/" class="logo"> &nbsp; </a>
          </mat-toolbar>
        }
        <app-sidenav (collapse)="onSidenavCollapse($event)"></app-sidenav>
      </mat-drawer>
    }

    <mat-drawer-content [class.content-shifted]="!sidenavCollapsed">
      <div class="main-content-wrap">
        <div class="rightside-content-hold">
          <div class="content-container">
            <router-outlet></router-outlet>
          </div>
        </div>
      </div>
    </mat-drawer-content>

    <mat-drawer #options position="end" class="menu-sizer">
      <div class="layout-options-header op-header mat-elevation-z1">&nbsp;</div>
    </mat-drawer>
  </mat-drawer-container>
</div>
